/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_CrystalInputs */

const en_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Crystals`)
};

const ar_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلورة الزمن`)
};

const de_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Crystals`)
};

const es_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cristales de tiempo`)
};

const fr_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristaux de temps`)
};

const it_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristalli del Tempo`)
};

const ja_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時の結晶`)
};

const ko_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타임 크리스탈`)
};

const pt_br_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cristais do Tempo`)
};

const ru_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кристальное Время`)
};

const th_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คริสตัลแห่งกาลเวลา`)
};

const tr_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaman Kristalleri`)
};

const zh_cn_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时光宝石`)
};

const zh_tw_time_crystal = /** @type {(inputs: Time_CrystalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時光寶石`)
};

/**
* | output |
* | --- |
* | "Time Crystals" |
*
* @param {Time_CrystalInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const time_crystal = /** @type {((inputs?: Time_CrystalInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_CrystalInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_time_crystal(inputs)
	if (locale === "ar") return ar_time_crystal(inputs)
	if (locale === "de") return de_time_crystal(inputs)
	if (locale === "es") return es_time_crystal(inputs)
	if (locale === "fr") return fr_time_crystal(inputs)
	if (locale === "it") return it_time_crystal(inputs)
	if (locale === "ja") return ja_time_crystal(inputs)
	if (locale === "ko") return ko_time_crystal(inputs)
	if (locale === "pt_br") return pt_br_time_crystal(inputs)
	if (locale === "ru") return ru_time_crystal(inputs)
	if (locale === "th") return th_time_crystal(inputs)
	if (locale === "tr") return tr_time_crystal(inputs)
	if (locale === "zh_cn") return zh_cn_time_crystal(inputs)
	return zh_tw_time_crystal(inputs)
});